<div *transloco="let t">
	<vex-page-layout mode="card">
		<vex-page-layout-header class="pb-16 flex flex-col justify-center items-start">
			<div>
				<h1 class="title mt-0 mb-1">{{ t('sideboard.benutzerverwaltung') }}</h1>
				<vex-breadcrumbs [crumbs]="this.breadCrumbService.crumbs"></vex-breadcrumbs>
			</div>
		</vex-page-layout-header>
		<vex-page-layout-content [class.container]="false" [class.px-gutter]="true" class="-mt-6">
			@if (isLoading()) {
				<div class="card overflow-auto -mt-16">
					<div class="card p-6 flex items-center justify-center" style="min-height: 400px">
						<mat-progress-spinner color="primary" mode="indeterminate" diameter="50"></mat-progress-spinner>
					</div>
				</div>
			} @else {
				<div class="card overflow-auto -mt-16">
					<div class="card p-6">
						<div @stagger>
							<div class="section-header mb-6">
								<div class="flex flex-row gap-2 justify-start items-center">
									<h2 class="section-title">{{ t('permissionStages.manageGroups') }}</h2>
									<mat-icon [svgIcon]="icons.get('help')" [matTooltip]="t('permissionStages.titleDescription')"></mat-icon>
								</div>
							</div>
							<div class="flex flex-col">
								@for (permissionGroup of permissionGroups(); track permissionGroup) {
									<ara-pm-permission-group
										[permissionGroup]="permissionGroup"
										[isDevRole]="sessionService.isDevRole()"
										[keycloakId]="sessionService.getKeycloakUserID()"
										[showGroupName]="permissionGroups().length > 1"></ara-pm-permission-group>
									@if (permissionGroups().length > 1 && permissionGroups().indexOf(permissionGroup) < permissionGroups().length - 1) {
										<mat-divider class="my-3"></mat-divider>
									}
								} @empty {
									<p class="text-muted">{{ t('permissionStages.noGroups') }}</p>
								}
							</div>
						</div>
					</div>
				</div>
			}
		</vex-page-layout-content>
	</vex-page-layout>
</div>
